import { jsxs as t, jsx as e } from "react/jsx-runtime";
import m from "@mui/icons-material/Close";
import c from "@mui/material/AppBar";
import n from "@mui/material/IconButton";
import p from "@mui/material/Toolbar";
import { makeStyles as d } from "tss-react/mui";
import f from "../../Button/Button.js";
import h from "../SwipeableDrawer/SwipeableDrawerBase.js";
import B from "./MobileDialog.style.js";
const u = d()(B), x = ({
  children: r,
  open: a,
  onClose: s,
  dataTestid: i,
  dialogClass: l
}) => {
  const { classes: o } = u();
  return /* @__PURE__ */ t(
    h,
    {
      isOpen: a,
      onClose: s,
      dataTestid: i,
      classes: l,
      children: [
        /* @__PURE__ */ e(c, { position: "static", className: o.header, children: /* @__PURE__ */ t(p, { className: o.headercontent, children: [
          /* @__PURE__ */ e(
            f,
            {
              className: o.expandBtn,
              dataTestid: "dialogExpandBtn",
              onClick: s
            }
          ),
          /* @__PURE__ */ e(
            n,
            {
              edge: "start",
              size: "small",
              className: o.closeIcon,
              onClick: s,
              children: /* @__PURE__ */ e(m, {})
            }
          )
        ] }) }),
        r
      ]
    }
  );
}, w = x;
export {
  w as default
};
